
























































































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import * as helper from '@/assets/_js/helpers'
import { accessContext } from '@/eostransit'
const numeral = require('numeral')

@Component
export default class Staking extends Vue {
  private amount: string | null = null
  private asset: 'DAPP' | 'DAPPHDL' = 'DAPP'
  private numeral = numeral

  // computed
  get wallet() {
    return vxm.transit.wallet
  }

  get stakingData() {
    return vxm.modals.modalStaking
  }

  get action() {
    if (this.stakingData) return this.stakingData.action
    else return ''
  }

  get getNameLogo() {
    if (this.stakingData) {
      return helper.nameLogo(
        this.stakingData.pkg.provider,
        this.stakingData.detailedPkg.pkgJson,
        this.stakingData.detailedPkg.dspJson
      )
    } else
      return { name: '', pkgLogoUrl: require('@/assets/media/logos/eos.png') }
  }

  get prettyServiceString() {
    if (this.stakingData)
      return helper.prettyServiceString(this.stakingData.pkg.service)
    else return ''
  }

  get minStakeQuantity() {
    if (this.stakingData)
      return numeral(this.stakingData.pkg.min_stake_quantity).format('0,0.0000')
    else return ''
  }

  get userDappLiquid() {
    if (this.asset === 'DAPPHDL')
      return numeral(vxm.user.userLoginDapphdlData.balance).format('0,0.0000')
    else return numeral(vxm.user.userLoginDappLiquid).format('0,0.0000')
  }

  get userStakedBalance() {
    let staked = vxm.user.userLoginStakingTable.find(
      (s: any) =>
        s.provider === this.stakingData.pkg.provider &&
        s.service === this.stakingData.pkg.service
    )
    let stakedHdl = vxm.user.dapphdlStakingTable.find(
      (s: any) =>
        s.provider === this.stakingData.pkg.provider &&
        s.service === this.stakingData.pkg.service &&
        s.account === this.wallet.auth.accountName
    )
    if (this.asset === 'DAPPHDL') {
      if (stakedHdl) return numeral(stakedHdl.balance).format('0,0.0000')
      else return '0.0000'
    } else {
      if (staked) return numeral(staked.balance).format('0,0.0000')
      else return '0.0000'
    }
  }

  // method
  format(value: any, event: any) {
    return numeral(value).format('0,0.0000')
  }

  resetModal() {
    this.amount = null
  }

  handleOk(amount: string) {
    if (this.stakingData && this.stakingData.action === 'stake') {
      this.stake(amount)
    } else {
      this.unstake(amount)
    }
  }
  setDelay(i: number) {
    setTimeout(() => {
      vxm.user.getDappLiquid({
        account: this.wallet.auth.accountName,
        currentUser: true
      })
      vxm.user.getDapphdlData({
        account: this.wallet.auth.accountName,
        currentUser: true
      })
      vxm.user.getRefundTable({
        account: this.wallet.auth.accountName,
        currentUser: true
      })
      vxm.user.getStakingTable({
        account: this.wallet.auth.accountName,
        currentUser: true
      })
      vxm.dappservices.getAccountTable()
    }, 1000 * i)
  }

  updateUserLoginData() {
    for (let i = 1; i <= 5; i++) {
      this.setDelay(i)
    }
  }

  stake(amount: string) {
    vxm.alerts.setAlert({
      show: true,
      dismissible: false,
      title: 'Staking...',
      message: 'To stake please allow this action in your wallet.',
      variant: 'warning'
    })
    let data: any = {
      from: this.wallet.auth.accountName,
      provider: this.stakingData.pkg.provider,
      service: this.stakingData.pkg.service,
      quantity: numeral(amount).format('0.0000') + ' ' + this.asset
    }
    let contract = 'dappservices'
    if (this.asset === 'DAPPHDL') {
      contract = 'dappairhodl1'
      data = {
        owner: this.wallet.auth.accountName,
        provider: this.stakingData.pkg.provider,
        service: this.stakingData.pkg.service,
        quantity: numeral(amount).format('0.0000') + ' ' + this.asset
      }
    }
    if (this.stakingData)
      this.wallet.eosApi
        .transact(
          {
            delay_sec: vxm.core.settings.txDelaySec,
            actions: [
              {
                account: contract,
                name: 'stake',
                authorization: [
                  {
                    actor: this.wallet.auth.accountName,
                    permission: this.wallet.auth.permission
                  }
                ],
                data: data
              }
            ]
          },
          {
            broadcast: true,
            blocksBehind: 3,
            expireSeconds: 60
          }
        )
        .then((resp: any) => {
          this.updateUserLoginData()
          vxm.alerts.setAlert({
            show: true,
            dismissible: true,
            title: 'Successfully Staked!',
            message: amount + ' ' + this.asset + ' Tokens successfully staked.',
            variant: 'success',
            txId: resp.transaction_id,
            dismissSecs: 6,
            dismissCountDown: 6
          })
        })
        .catch((error: any) => {
          this.updateUserLoginData()
          vxm.alerts.setAlert({
            show: true,
            dismissible: true,
            title: 'Error while Staking!',
            message: 'Something went wrong: ' + error.message,
            variant: 'danger',
            dismissSecs: 8,
            dismissCountDown: 8
          })
        })
  }

  unstake(amount: string) {
    vxm.alerts.setAlert({
      show: true,
      dismissible: false,
      title: 'Unstaking...',
      message: 'To unstake please allow this action in your wallet.',
      variant: 'warning'
    })
    let data: any = {
      to: this.wallet.auth.accountName,
      provider: this.stakingData.pkg.provider,
      service: this.stakingData.pkg.service,
      quantity: numeral(amount).format('0.0000') + ' ' + this.asset
    }
    let contract = 'dappservices'
    if (this.asset === 'DAPPHDL') {
      contract = 'dappairhodl1'
      data = {
        owner: this.wallet.auth.accountName,
        provider: this.stakingData.pkg.provider,
        service: this.stakingData.pkg.service,
        quantity: numeral(amount).format('0.0000') + ' ' + this.asset
      }
    }
    if (this.stakingData)
      this.wallet.eosApi
        .transact(
          {
            delay_sec: vxm.core.settings.txDelaySec,
            actions: [
              {
                account: contract,
                name: 'unstake',
                authorization: [
                  {
                    actor: this.wallet.auth.accountName,
                    permission: this.wallet.auth.permission
                  }
                ],
                data: data
              }
            ]
          },
          {
            broadcast: true,
            blocksBehind: 3,
            expireSeconds: 60
          }
        )
        .then((resp: any) => {
          this.updateUserLoginData()
          vxm.alerts.setAlert({
            show: true,
            dismissible: true,
            title: 'Successfully Unstaked!',
            message:
              amount + ' ' + this.asset + ' Tokens successfully unstaked.',
            variant: 'success',
            txId: resp.transaction_id,
            dismissSecs: 6,
            dismissCountDown: 6
          })
        })
        .catch((error: any) => {
          this.updateUserLoginData()
          vxm.alerts.setAlert({
            show: true,
            dismissible: true,
            title: 'Error while Unstaking!',
            message: 'Something went wrong: ' + error.message,
            variant: 'danger',
            dismissSecs: 8,
            dismissCountDown: 8
          })
        })
  }

  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
